import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as numeral from 'numeral';
import * as _ from 'underscore';
import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-donut',
	styleUrls: ['./donut.component.css'],
	templateUrl: './donut.component.html'
})
export class DonutComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
	@ViewChild('chartElement', { static: true }) chartElement: ElementRef;
	@ViewChild('donutLegendElement') legendElement: ElementRef;
	@Input() hasProfileImg: boolean;
	@Input() chartData: any;
	@Input() chartConfigurationObj;
	@Input() sectiontitle;
	@Input() isR8;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() hightLightLabels: EventEmitter<any> = new EventEmitter();

	public hasData = true;
	public chartObj: any;
	public renderedImage: any;
	private seriesData: any;
	private pieObj = {};
	private tooltip = {};
	public isR104: boolean = false;
	public isR103: boolean = false;

	constructor(protected analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.isR8 = this.isR8 == 'true' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		setTimeout(() => {
			this.reDrawImage();
		}, 1000);
	}

	ngAfterViewInit(): void {
		jQuery('.highcharts-container').css('zIndex', 999);
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		if (changes['chartData'] || changes['chartConfigurationObj']) {
			if (this.chartData) {
				if (this.chartData.length > 0) {
					this.drawDonutChart();
				}
			}
		}
	}

	ngOnDestroy(): void {
		if (this.chartObj) {
			this.chartObj.destroy();
		}
	}

	setTooltipObj(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		if (this.chartConfigurationObj.addSeriesNameToLables) {
			let pointFormat = '';
			let headerFormat = '';
			if (this.chartConfigurationObj.type === 'pieDonut') {
				this.chartConfigurationObj.showPercentageToolTip =
					typeof this.chartConfigurationObj.showPercentageToolTip === 'undefined'
						? true
						: this.chartConfigurationObj.showPercentageToolTip;
				if (this.chartConfigurationObj.sigleLineToolTip) {
					pointFormat = `<span style="color:{point.color};font-size: 13px;">●</span><span style="color:${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '14px'
					};">{point.y: ,.0f} {point.name}</span>`;
				} else {
					pointFormat = `<span style="color:{point.color};font-size: 20px;">● </span> <span style="color:${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '16px'
					};">{point.name}</span><br/>`;
					if (this.chartConfigurationObj.showPercentageToolTip) {
						headerFormat = `<span style="font-size: 14px;color: ${
							this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
						};font-weight:700">{point.percentage:.1f}% ({point.y: ,.0f})</span><br/>`;
					} else {
						headerFormat = `<span style="font-size: ${
							this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '14px'
						};color: ${
							this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
						};font-weight:700">{point.y: ,.0f}</span><br/>`;
					}
				}
			} else {
				if (this.chartConfigurationObj.devicesTooltip) {
					if (this.chartConfigurationObj.tooltipFloatValue) {
						pointFormat = `<div style="padding:0px;color:${
							this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
						};font-size: ${
							this.chartConfigurationObj.tooltipFontSize
								? this.chartConfigurationObj.tooltipFontSize
								: '16px; text-align:center'
						};"><div class="tooltip_name">{point.name}</div><div class="tooltip_value" style="text-align:center; font-weight:bold">{point.y: .2f}%</div></div>`;
					} else {
						pointFormat = `<div style="padding:0px;color:${
							this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
						};font-size: ${
							this.chartConfigurationObj.tooltipFontSize
								? this.chartConfigurationObj.tooltipFontSize
								: '16px; text-align:center'
						};"><div class="tooltip_name">{point.name}</div><div class="tooltip_value" style="text-align:center; font-weight:bold">{point.y}</div></div>`;
					}
					headerFormat = '';
				} else if (this.chartConfigurationObj.seriesName && !this.isR103) {
					pointFormat = `<span style="color:{point.color};font-size: 20px;">●</span> <span style="color:${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '16px'
					};">{point.name} {series.name}</span><br/>`;
					headerFormat = `<span style="font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '14px'
					};color: ${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-weight:700">{point.percentage:.1f}% ({point.y: ,.0f})</span><br/>`;
				} else if (this.chartConfigurationObj.seriesName && this.isR103) {
					pointFormat = `<span style="color:${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#263238'
					};font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '12px'
					};">{point.name}: {point.percentage:.2f}% </span><br/>`;
				} else {
					pointFormat = `<span style="color:{point.color};font-size: 20px;">●</span> <span style="color:${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '16px'
					};">{point.name}</span><br/>`;
					headerFormat = `<span style="font-size: ${
						this.chartConfigurationObj.tooltipFontSize ? this.chartConfigurationObj.tooltipFontSize : '14px'
					};color: ${
						this.chartConfigurationObj.tooltipTextColor ? this.chartConfigurationObj.tooltipTextColor : '#FFF'
					};font-weight:700">{point.percentage:.1f}% ({point.y: ,.0f})</span><br/>`;
				}
			}
			this.tooltip = {
				borderRadius: this.chartConfigurationObj.tooltipRadius !== null ? this.chartConfigurationObj.tooltipRadius : 8,
				borderWidth: this.chartConfigurationObj.tolltipBorderWidth ? this.chartConfigurationObj.tolltipBorderWidth : 0,
				enabled:
					this.chartConfigurationObj.isTooltipEnabled === false ? this.chartConfigurationObj.isTooltipEnabled : true,
				followPointer: this.chartConfigurationObj.followPointer ? true : false,
				headerFormat,
				hideDelay: 50,
				pointFormat,
				useHTML: true
			};
			if (UtilityService.isUndefined(this.chartConfigurationObj.tooltipBackgroundColor)) {
				this.tooltip['backgroundColor'] = '#000';
			} else if (this.chartConfigurationObj.tooltipBackgroundColor != null) {
				this.tooltip['backgroundColor'] = this.chartConfigurationObj.tooltipBackgroundColor;
			}
		} else if (this.chartConfigurationObj.pieChartToolTip) {
			this.chartConfigurationObj.tooltip = {
				backgroundColor: '#fff',
				shadow: !UtilityService.isUndefinedOrNull(this.chartConfigurationObj.shadow)
					? this.chartConfigurationObj.shadow
					: true,
				borderColor:
					this.chartConfigurationObj.tooltipBorderColor !== null
						? this.chartConfigurationObj.tooltipBorderColor
						: undefined,
				borderRadius: this.chartConfigurationObj.tooltipRadius !== null ? this.chartConfigurationObj.tooltipRadius : 10,
				borderWidth:
					this.chartConfigurationObj.tolltipBorderWidth !== null ? this.chartConfigurationObj.tolltipBorderWidth : 1,
				followPointer: this.chartConfigurationObj.followPointer ? true : false,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					self.hightLightLabels.emit(this.point.index);
					let value = '';
					if (typeof this.y === 'number') {
						value = this.y.toLocaleString('en', { maximumSignificantDigits: 21 });
					} else {
						value = this.y;
					}
					return (
						// tslint:disable-next-line: prefer-template
						'<div style="text-align:center; padding: 0px" class="tooltipStyle">' +
						'<b>' +
						this.point.name +
						'</b><br/><br/><span class="dayparttime">' +
						this.point.dayparttime +
						'</span><span class="r1102dayparttime" style="display:none; font-weight:400">M-Su: ' +
						this.point.dayparttime +
						' ' +
						this.point.timezone +
						' </span><br/><br/><b>' +
						numeral(this.y).format('0,0') +
						'</b></div>'
					);
				},
				style: {
					fontSize: 12
				},
				useHTML: true
			};
		} else {
			this.tooltip = this.isR104
				? {
						enabled: this.chartConfigurationObj.isTooltipEnabled,
						followPointer: false,
						backgroundColor: '#FFFFFFF2',
						borderRadius: 6,
						borderWidth: 1,
						// tslint:disable-next-line: object-literal-shorthand
						formatter: function (): string {
							let value = '';
							if (typeof this.y === 'number') {
								value = this.y.toLocaleString('en', { maximumSignificantDigits: 21 });
							} else {
								value = this.y;
							}
							// tslint:disable-next-line: prefer-template
							return (
								'<div style="font-size: 10px; font-weight: 400; line-height: 13.62px; text-align: center; color: #4A4A4A;">' +
								this.key +
								' ' +
								value +
								'</div>'
							);
						},
						useHtml: true
				  }
				: this.isR8
				? {
						enabled: this.chartConfigurationObj.isTooltipEnabled,
						// tslint:disable-next-line: object-literal-shorthand
						formatter: function (): string {
							let value = '';
							if (typeof this.y === 'number') {
								value = this.y.toLocaleString('en', { maximumSignificantDigits: 21 });
							} else {
								value = this.y;
							}
							// tslint:disable-next-line: prefer-template
							return this.key + ' : <b>' + this.percentage.toFixed(2) + '%</b>';
						},
						useHtml: true
				  }
				: {
						enabled: this.chartConfigurationObj.isTooltipEnabled,
						// tslint:disable-next-line: object-literal-shorthand
						formatter: function (): string {
							let value = '';
							if (typeof this.y === 'number') {
								value = this.y.toLocaleString('en', { maximumSignificantDigits: 21 });
							} else {
								value = this.y;
							}
							// tslint:disable-next-line: prefer-template
							return (
								this.series.name +
								' : <b>' +
								(this.series.name === 'Cost' ? numeral(value).format('0.00') + '% </b>' : value + '</b>')
							);
						},
						useHtml: true
				  };
		}
	}
	setUpPieObj(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		if (this.chartConfigurationObj.type === 'pieDonut') {
			this.seriesData = this.chartData;
			this.pieObj = {
				borderWidth:
					this.chartConfigurationObj && this.chartConfigurationObj.pieBorderWidth
						? this.chartConfigurationObj.pieBorderWidth
						: 0,
				dataLabels: {
					distance: this.chartConfigurationObj.dataLabelsDistance,
					enabled: UtilityService.isUndefined(this.chartConfigurationObj.datalabelsEnabled)
						? true
						: this.chartConfigurationObj.datalabelsEnabled,
					// tslint:disable-next-line: object-literal-shorthand
					formatter: function (): string {
						if (self.chartConfigurationObj.lineBreak) {
							return `<div style="text-align:center;width:100%"><b>${
								this.point.name
							}</b> <br/><div style="text-align:center">${this.percentage.toFixed(1)} %</div></div>`;
						}

						return `<b>${this.point.name}</b>: ${this.percentage.toFixed(1)} %`;
					}
				},
				innerSize: `${this.chartConfigurationObj.innerSize}%` || '50%',
				showInLegend: this.chartConfigurationObj.showInLegend,
				size: this.chartConfigurationObj.size || '75%'
			};
			this.setTooltipObj();
		} else if (this.chartConfigurationObj.type === 'pieChart') {
			this.seriesData = [
				{
					data: this.chartData,
					name: UtilityService.upperCaseFirst(this.chartConfigurationObj.seriesName)
				}
			];
			this.pieObj = {
				borderColor: '#efefef',
				borderWidth: 0,
				dataLabels: {
					enabled: false
				},
				events: {
					// tslint:disable-next-line: object-literal-shorthand only-arrow-functions
					mouseOut: function (): void {
						self.hightLightLabels.emit(null);
					}
				},
				innerSize: this.chartConfigurationObj.innerSize ? `${this.chartConfigurationObj.innerSize}%` : '0%',
				states: {
					hover: {
						halo: {
							size: 1
						}
					}
				}
			};
			this.setTooltipObj();
		} else {
			this.seriesData = [
				{
					data: this.chartData,
					name: UtilityService.upperCaseFirst(this.chartConfigurationObj.seriesName)
				}
			];
			this.pieObj = {
				borderWidth:
					this.chartConfigurationObj && this.chartConfigurationObj.pieBorderWidth
						? this.chartConfigurationObj.pieBorderWidth
						: 0,
				dataLabels: {
					enabled: this.chartConfigurationObj.datalabelsEnabled,
					format: '<b>{point.name}</b>: {point.percentage:.2f} %'
				},
				innerSize:
					this.chartConfigurationObj && this.chartConfigurationObj.innerSize
						? `${this.chartConfigurationObj.innerSize}%`
						: '50%',
				showInLegend: this.chartConfigurationObj.showInLegend
			};
			this.setTooltipObj();
		}
	}

	drawDonutChart(): void {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.seriesData = {};
		if (typeof this.chartConfigurationObj.isTooltipEnabled === 'undefined') {
			this.chartConfigurationObj.isTooltipEnabled = true;
		}
		this.setUpPieObj();
		Highcharts.setOptions({
			lang: {
				thousandsSep: ','
			}
		});
		if (this.isR104) {
			this.chartObj = Highcharts.chart({
				chart: {
					backgroundColor: 'transparent',
					events: this.chartConfigurationObj.events ? this.chartConfigurationObj.events : {},
					height: 500,
					margin: this.chartConfigurationObj.margin || [40, 10, 10, 10],
					renderTo: this.chartElement.nativeElement,
					type: 'pie',
					width: this.chartConfigurationObj.svgWidth || 500
				},
				credits: {
					enabled: false
				},
				legend: {
					align: 'center',
					enabled: !this.chartConfigurationObj.enableCustomLegend,
					floating: UtilityService.isUndefined(this.chartConfigurationObj.legendFloating)
						? true
						: this.chartConfigurationObj.legendFloating,
					itemDistance: this.chartConfigurationObj.legendItemDistance || 20,
					// tslint:disable-next-line: object-literal-shorthand
					labelFormatter: function (): string {
						let legendText = self.chartConfigurationObj.legendText;
						legendText = ` ${this['percentage'].toFixed(1)}%`;
						return `${this.name}${legendText}`;
					},
					layout: 'horizontal',
					verticalAlign: this.chartConfigurationObj.verticalAlign || 'top',
					symbolRadius: 4,
					width: this.chartConfigurationObj.legendWidth,
					x: this.chartConfigurationObj.xLegendPos || -15,
					y: this.chartConfigurationObj.yLegendPos
				},
				plotOptions: {
					pie: this.pieObj,
					series: {
						states: {
							inactive: {
								opacity: 1
							}
						}
					}
				},
				series: this.seriesData,
				subtitle: {
					text: ''
				},
				title: {
					text: this.chartConfigurationObj.title ? this.chartConfigurationObj.title : ''
				},
				tooltip: this.chartConfigurationObj.tooltip ? this.chartConfigurationObj.tooltip : this.tooltip
			});
		} else {
			this.chartObj = Highcharts.chart({
				chart: {
					backgroundColor: 'transparent',
					events: this.chartConfigurationObj.events ? this.chartConfigurationObj.events : {},
					height: this.chartConfigurationObj.svgHeight,
					margin: this.chartConfigurationObj.margin || [40, 10, 10, 10],
					renderTo: this.chartElement.nativeElement,
					type: 'pie',
					width: this.chartConfigurationObj.svgWidth || 500
				},
				credits: {
					enabled: false
				},
				legend: {
					align: this.chartConfigurationObj?.align ? this.chartConfigurationObj?.align : 'center',
					enabled: !this.chartConfigurationObj.enableCustomLegend,
					floating: UtilityService.isUndefined(this.chartConfigurationObj.legendFloating)
						? true
						: this.chartConfigurationObj.legendFloating,
					itemDistance: this.chartConfigurationObj.legendItemDistance || 20,
					// tslint:disable-next-line: object-literal-shorthand
					labelFormatter: function (): string {
						let legendText = self.chartConfigurationObj.legendText;
						legendText = legendText ? legendText : '';
						legendText = self.chartConfigurationObj.addSeriesNameToLables
							? self.chartConfigurationObj?.specialLegendText
								? `: ${this['percentage'].toFixed(2)}%`
								: ` (${this['percentage'].toFixed(1)}%)`
							: legendText;
						return `${this.name}${legendText}`;
					},
					layout: this.chartConfigurationObj?.layout ? this.chartConfigurationObj?.layout : 'horizontal',
					verticalAlign: this.chartConfigurationObj.verticalAlign || 'top',
					width: this.chartConfigurationObj.legendWidth,
					x: this.chartConfigurationObj.xLegendPos || -15,
					y: this.chartConfigurationObj.yLegendPos,
					symbolRadius: this.chartConfigurationObj?.symbolRadius ? this.chartConfigurationObj?.symbolRadius : 50,
					itemMarginTop: this.chartConfigurationObj?.itemMarginTop ? this.chartConfigurationObj?.itemMarginTop : 2,
					padding: this.chartConfigurationObj?.padding ? this.chartConfigurationObj?.padding : 8
				},
				plotOptions: {
					pie: this.pieObj,
					series: {
						states: {
							inactive: {
								opacity: 1
							}
						}
					}
				},
				series: this.seriesData,
				subtitle: {
					text: ''
				},
				title: {
					text: this.chartConfigurationObj.title ? this.chartConfigurationObj.title : ''
				},
				tooltip: this.chartConfigurationObj.tooltip ? this.chartConfigurationObj.tooltip : this.tooltip
			});
		}
		jQuery(this.chartObj.container).css('margin', '0 auto');
		if (this.hasProfileImg) {
			this.drawImage();
		}
	}

	updateLegendArray(legendItem: any): void {
		const legendObj: any = _.findWhere(this.chartConfigurationObj.customLegendData, { index: legendItem.index });
		if (legendObj) {
			legendObj.active = !legendObj.active;
		}
		this.updateSeriesObj();
	}

	updateSeriesObj(): void {
		if (this.chartConfigurationObj.type === 'pieDonut') {
			const selectedLegendItems = _.where(this.chartConfigurationObj.customLegendData, { active: true });
			const selectedIndexes = _.pluck(selectedLegendItems, 'index');
			const chartData = JSON.parse(JSON.stringify(this.chartData));
			for (const chartObj of chartData) {
				chartObj.data = _.filter(chartObj.data, (obj: any, index) => {
					return _.indexOf(selectedIndexes, index) !== -1;
				});
			}
			for (let i = 0; i < chartData.length; i++) {
				this.chartObj.series[i].update(chartData[i]);
			}
		}
	}
	drawImage(): void {
		((chart) => {
			const width = chart.chartWidth;
			const xPos = (width - 75 / 2 - 30) / 1.419;
			this.renderedImage = chart.renderer.image('assets/images/profile.png', xPos, 88, 20, 20).add();
		})(this.chartObj);
	}

	reDrawImage(): void {
		if (this.renderedImage) {
			const width = this.chartObj.chartWidth;
			const xPos = (width - 75 / 2 - 30) / 1.419;
			this.renderedImage.attr('x', xPos);
		}
	}
}
